import React, {Component} from 'react';
import './MainMenu.css';
import DebitMenu from './DebitMenu';

class MainMenu extends Component {
    render() {
        const defaultMainMenuStyle="subnavbtn p-0 font-weight-bold";
        return <DebitMenu defaultMainMenuStyle={defaultMainMenuStyle} {...this.props}/>
      }
}
export default MainMenu;